
import { apiFetch } from './client';
import type { KeyStatus, SetKeyPayload } from '../types/contracts';

export const settingsApi = {
  getKeyStatus: ()                      => apiFetch<KeyStatus[]>('/api/settings/keys'),
  setKey:       (p: SetKeyPayload)      => apiFetch<void>('/api/settings/keys',  { method: 'PUT',    body: JSON.stringify(p) }),
  deleteKey:    (provider: string)      => apiFetch<void>(`/api/settings/keys/${provider}`, { method: 'DELETE' }),
};
